import script from "./Card.vue?vue&type=script&lang=ts&setup=true"
export * from "./Card.vue?vue&type=script&lang=ts&setup=true"

import "./Card.vue?vue&type=style&index=0&id=593ac878&lang=less&scoped=true"

import exportComponent from "/Users/chengyanbin/Codes/Daming/ksdm_offline/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593ac878"]])

export default __exports__